import { useT } from '@repo/ui/hooks'
import { FileTextIcon, Loader2 } from 'lucide-react'

import { MarkdownWrapper } from '@/components/MarkdownWrapper'
import { ReportTemplate } from '@/store/report-templates/types'

export function ReportDisplay({
  isLoading,
  report,
  reportTemplateName,
}: {
  isLoading: boolean
  report?: string
  reportTemplateName: ReportTemplate['name']
}) {
  const { tc, t } = useT({ keyPrefix: 'reports.display' })

  if (isLoading) {
    return (
      <div className="flex h-[300px] flex-col items-center justify-center">
        <Loader2 className="text-primary-100 mb-4 size-16 animate-spin" />
        <p className="text-primary-600 text-base">
          {tc('generating', { cfl: true })} {reportTemplateName}...
        </p>
        <p className="text-primary-400 mt-1 text-sm">{t('loading.description')}</p>
      </div>
    )
  }

  if (report) {
    return (
      <div className="prose prose-sm min-h-[300px] max-w-none">
        <MarkdownWrapper content={report} className="text-primary" />
      </div>
    )
  }

  return (
    <div className="flex h-[300px] items-center justify-center">
      <div className="text-center">
        <FileTextIcon className="text-primary-200 mx-auto mb-4 size-16" />
        <p className="text-primary-600 text-base">
          {t('ready.title')} <span className="font-bold">{reportTemplateName}</span>
        </p>
        <p className="text-primary-400 mt-1 text-sm">{t('ready.description')}</p>
      </div>
    </div>
  )
}
